import { useSelector } from 'react-redux';
import type { AccountState } from 'ext/entities/account';

/**
 * Hook to get the studio URL from state.
 * Use this instead of directly accessing import.meta.env.STUDIO_URL
 * to support region-based URLs injected by the extension.
 *
 * The default value (import.meta.env.STUDIO_URL) is set at the injection point
 * in each builder's createInitialState function.
 *
 * @returns The studio URL from state
 */
export const useStudioUrl = (): string => {
  return useSelector(
    (state: { account: AccountState }) => state.account?.studioUrl ?? ''
  );
};

/**
 * Non-hook version for sagas/non-component code.
 * Gets the studio URL from state.
 *
 * The default value (import.meta.env.STUDIO_URL) is set at the injection point
 * in each builder's createInitialState function.
 *
 * @param state - Redux state with account slice
 * @returns The studio URL from state
 */
export const getStudioUrlFromState = (state: {
  account: AccountState;
}): string => {
  return state.account?.studioUrl ?? '';
};
